"use strict";

var _require = require('../../../helpers'),
    computeCopies = _require.computeCopies;

module.exports = function (accumulator, order, product, component) {
  var copies = computeCopies(component);

  if (Number.isNaN(copies)) {
    console.error(component);
    throw new Error("numCopies computed NaN for ".concat(component.component_type));
  }

  return copies;
};